<template>
    <div class="clients">
      <div class="pageContent">
        <heading-wrap>
           <span slot="title">Clients</span>
           <span slot="link">
            <router-link v-if="isAdmin" class="btn btn-primary pull-right" :to="{ path: `client/add` }">
              Add Client
            </router-link>
           </span>
        </heading-wrap>

        <spinner v-if="loading" />
        <search-box v-model="search" name="clients..." />
          <select v-if="isAdmin" v-model="statusFilter" @change="statusFilterCall" :style="{maxWidth: '10%', marginBottom: '1rem'}" class="form-control col-md-5 mr-sm-2">
            <option selected value="">Status</option>
            <option value="tsl_client">TSL Client</option>
            <option value="demo">Demo</option>
            <option value="trial">Trial</option>
            <option value="contract">Contract</option>
            <option value="deactivated">De-Activated</option>
          </select>
          <!-- <select :style="{maxWidth: '33%', marginRight: '1rem'}" class="form-control col-md-5 SearchBox form-inline mr-sm-2">
            <option>Trial</option>
            <option>Contract</option>
            <option>De-Activated</option>
          </select>
          <select :style="{maxWidth: '32.05%'}" class="form-control col-md-5 SearchBox form-inline mr-sm-2">
            <option>Demo</option>
            <option>Trial</option>
            <option>Contract</option>
            <option>De-Activated</option>
          </select> -->
        <slot-table id="clientTable" :data="filteredClients" :columns="table.columns">
          <template slot="name" slot-scope="props">
            <router-link :to="{ path: `client/${props.item.hash_id}` }">
                <span class="clients__logo">
                  <client-logo v-if="props.item.logo" type="small" :path="props.item.logo"/>
                  <span>{{ props.item.name }}</span>
                </span>
            </router-link>
          </template>

          <template slot="date_created" slot-scope="props">
            <span>{{props.item.date_created.value | formatDate("YYYY") }}</span>
          </template>

          <template v-if="isAdmin" slot="end_date" slot-scope="props">
            <span>{{props.item.end_date | formatDate("YYYY") }}</span>
          </template>

          <template v-if="isAdmin" slot="start_date" slot-scope="props">
            <span>{{props.item.start_date | formatDate("YYYY") }}</span>
          </template>

          <template v-if="isAdmin" slot="no_tier_1" slot-scope="props">
            <span>{{ formatDownloadSingleCounter(props.item.t1_download_counter, props.item.number_tier_1_outputs) }}</span>
          </template>

          <template v-if="isAdmin" slot="no_tier_2" slot-scope="props">
            <span>{{ formatDownloadSingleCounter(props.item.t2_download_counter, props.item.number_tier_2_outputs) }}</span>
          </template>

          <template slot="last_login" slot-scope="props">
              <span v-if="getUserLastLogin(props.item.associatedUsers)"> {{ getUserLastLogin(props.item.associatedUsers) | fromNow}} </span>
          </template>

          <template slot="last_rendered" slot-scope="props">
              <span v-if="getUserLastRendered(props.item.associatedUsers)"> {{ getUserLastRendered(props.item.associatedUsers) | fromNow}} </span>
          </template>

          <template slot="clientsActions" slot-scope="props">
            <span v-if="props.item.clientsActions && isAdmin">
              <button title="expand" @click="expandView(props.item)" class="btn btn-info btn-xs">
                  <i class="fa fa-chevron-left" aria-hidden="true"></i>
              </button>
            </span>
          </template>
        </slot-table>
      </div>

      <div id="sidebar" class="sidebar">
        <button title="close" @click="hideView()" class="btn btn-info btn-xs">
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </button>
        <div class="d-flex1">
          <h1 :style="{marginLeft: '1%'}">{{currentClient.name}}</h1>
          <div v-if="isAdmin" >
              <span :class="`label label-${currentClient.is_active ? 'danger' : 'success'} table__cursor-pointer`" @click="clientStatus(currentClient.hash_id)">{{ (currentClient.status !== 'deactivated') ? 'De-Activate' : 'Activate'}}</span>
              <br/>
              <router-link :style="{marginTop: '1rem'}" class="btn btn-warning btn-sm" :to="{ path: `client/${currentClient.hash_id}/edit` }">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
              </router-link>
              <button-cta :style="{marginLeft: '.6rem', marginTop: '1rem'}" title="confirm" data-modalType="deleteClient" :data-modalID="currentClient.hash_id" :data-modalField="currentClient.name" :onClick="onLaunchModal" class="btn btn-danger btn-sm">
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button-cta>
          </div>
        </div>
        <hr />
        <div class="card-container white">
          <div class="d-flex1">
            <h4>Associated Users</h4>
            <div>
              <button-cta :style="{marginInline: '0.5rem'}" title="Show Stats" data-modalType="showUsageStats" :data-modalID="currentClient.hash_id" :data-modalField="currentClient.name" :onClick="onLaunchModal">
                Show Stats
              </button-cta>
            <button-cta  :style="{marginInline: '0.5rem'}" title="Add users to client" data-modalType="assignUsersToClient" :data-modalID="currentClient.hash_id" :data-modalField="currentClient.name" :onClick="onLaunchModal"> Add New Users </button-cta>
            </div>
          </div>
          <slot-table :activeSortData="sorting" @dispatchSortEvent="sortEvent" :editable="true" :data="associatedUsers" :sortable="true" :allowedSortColumns="userTableSortables" :columns="userTable.columns">
            <template slot="date_created" slot-scope="props">
              <span>{{props.item.date_created | formatDate("YYYY") }}</span>
            </template>
            <template slot="clientUserActions" slot-scope="props">
            <span>
              <router-link class="btn btn-warning btn-xs" :to="{ path: `user/${props.item.hash_id}/edit` }">
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </router-link>
              <button-cta title="confirm" data-modalType="deleteUser" :data-modalID="props.item.hash_id" :data-modalField="props.item.name" :onClick="onLaunchModal" class="btn btn-danger btn-xs">
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button-cta>
              <button-cta title="confirm" data-modalType="resetUser" :data-modalID="props.item.hash_id" :data-modalField="props.item.name" :onClick="onLaunchModal"
                           class="btn btn-danger btn-xs">
                <i class="fa fa-shield" aria-hidden="true"></i>
              </button-cta>
              <span :class="`label label-${props.item.is_active ? 'danger' : 'success'} table__cursor-pointer`" @click="userStatus(props.item.hash_id)">{{ props.item.is_active ? 'De-Activate' : 'Activate'}}</span>
            </span>
            </template>
            <template slot="last_login" slot-scope="props">
              <span v-if="props.item.last_login">{{ props.item.last_login.date | fromNow }} </span>
            </template>
            <template slot="last_rendered" slot-scope="props">
              <span v-if="props.item.last_render">{{ props.item.last_render.date | fromNow }} </span>
            </template>
          </slot-table>
          <portal to="globalModal">
            <modal-client-confirm :show="showModal.deleteClient" :confirmId="modalId" :field="modalField" @close="toggleModal('deleteClient')" />
            <modal-client-stats :show="showModal.showUsageStats" :confirmId="modalId" :field="modalField" @close="toggleModal('showUsageStats')" />
            <modal-assign-users :show="showModal.assignUsersToClient" :confirmId="modalId" :field="modalField" @addedUsers="pushUsers" @close="toggleModal('assignUsersToClient')" />
            <modal-user-confirm :show="showModal.deleteUser" :type="modalType" :confirmId="modalId" :field="modalField" @close="toggleModal('deleteUser')"/>
            <modal-reset-user :show="showModal.resetUser" :type="modalType" :confirmId="modalId" :field="modalField" @close="toggleModal('resetUser')"/>
          </portal>
        </div>
      </div>

    </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import ButtonCta from '@/components/Button/button'
import SlotTable from '@/components/Table/table'
import ClientLogo from '@/components/ClientLogo/client-logo'
import {clientMixin} from '@/mixins/clientMixin'
import {modalMixin} from '@/mixins/modalMixin'
import {userMixin} from '@/mixins/userMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import Spinner from '@/components/SpinnerIcon/spinner'
import SearchBox from '@/components/SearchBox/searchbox'
import ModalClientConfirm from '@/components/Modal/clients/modal-client-confirm'
import Checkbox from '@/components/Form/Checkbox/checkbox'
import ModalUserConfirm from '@/components/Modal/users/modal-user-confirm'
import ModalResetUser from '@/components/Modal/users/modal-reset-user'
import ModalAssignUsers from '@/components/Modal/clients/modal-assign-users'
import ModalClientStats from '@/components/Modal/clients/modal-client-stats'
import { assoc, map } from 'ramda'

export default {
  name: 'Clients',
  mixins: [clientMixin, modalMixin, notificationMixin, userMixin],
  props: {
    isAdmin: Boolean
  },
  components: {
    HeadingWrap,
    ButtonCta,
    SlotTable,
    Spinner,
    ClientLogo,
    SearchBox,
    ModalClientConfirm,
    Checkbox,
    ModalUserConfirm,
    ModalResetUser,
    ModalAssignUsers,
    ModalClientStats
  },
  mounted () {
    if (!this.isAdmin) {
      this.table.columns = Object.fromEntries(Object.entries(this.table.columns).filter(([key]) => key !== 'status' && key !== 'start_date' && key !== 'end_date' && key !== 'no_tier_1' && key !== 'no_tier_2'))
    }
  },
  data: () => ({
    // loading: true,
    search: '',
    statusFilter: '',
    allClients: '',
    rowActive: false,
    deleteId: null,
    sorting: [],
    sortData: null,
    last_login_sort_dir: true,
    last_rendered_sort_dir: true,
    table: {
      columns: {
        name: 'Client',
        user_count: 'User Count',
        campaigns: 'Campaign Count',
        status: 'Status',
        start_date: 'Start Date',
        end_date: 'End Date',
        // no_tier_1: 'HTML/PSD Downloads / Limit',
        // no_tier_2: 'AE Downloads / Limit',
        date_created: 'Date Created',
        clientsActions: ''
      }
    },
    userTable: {
      columns: {
        name: 'Name',
        email: 'Email',
        roleName: 'Role',
        client_names: 'Associated Clients',
        last_login: 'Last Login',
        last_rendered: 'Last Rendered',
        clientUserActions: 'Actions'
      }
    },
    userTableSortables: [
      {name: 'Last Login', key: 'last_login'},
      {name: 'Last Rendered', key: 'last_rendered'}
    ],
    currentClient: {},
    showAssociatedUsers: false
  }),
  created () {
    this.startLoading()
    const includeAssociatedUsers = 1
    this.getClients(includeAssociatedUsers).then(() => {
      this.finishLoading()
    }, error => {
      this.finishLoading()
      this.addNotification('danger', error)
    })
  },
  computed: {
    associatedUsers () {
      let newVal = null
      try {
        newVal = [...this.currentClient.associatedUsers]
      } catch (err) {
        newVal = null
      }
      if (this.sortData === null || this.currentClient.associatedUsers.length < 2) {
        return this.currentClient.associatedUsers
      } else {
        for (let index = 0; index + 1 < newVal.length; index++) {
          if (newVal[index][this.sortData.sortKey] === undefined) {
            newVal[index][this.sortData.sortKey] = '0'
          }
          if (newVal[index + 1][this.sortData.sortKey] === undefined) {
            newVal[index + 1][this.sortData.sortKey] = '0'
          }
          let thisidxval = newVal[index][this.sortData.sortKey].date
          let nextidxval = newVal[index + 1][this.sortData.sortKey].date
          if (this.sortData.sortDirection === 'asc') {
            if (thisidxval < nextidxval) {
              [newVal[index], newVal[index + 1]] = [newVal[index + 1], newVal[index]]
            }
          } else {
            if (thisidxval > nextidxval) {
              [newVal[index], newVal[index + 1]] = [newVal[index + 1], newVal[index]]
            }
          }
        }
        return newVal
      }
    },
    formattedClients () {
      // add clientActions key/value to data
      return map(item => assoc('clientsActions', true, item), this.clients)
    },
    filteredClients () {
      if (this.statusFilter) {
        return map(item => assoc('clientsActions', true, item), this.statusFilterCall())
      }
      return this.formattedClients.filter(client => {
        return client.name.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  methods: {
    pushUsers (e) {
      let users = []
      e.forEach((val) => {
        users.push(this.users.find((user) => {
          return user.hash_id === val
        }))
      })
      this.currentClient.associatedUsers = users
    },
    statusFilterCall () {
      if (this.statusFilter) {
        return this.clients.filter(cl => {
          return cl.status === this.statusFilter
        })
      }
    },
    sortEvent (e) {
      if (e.sortKey === 'last_rendered') {
        if (!this.last_rendered_sort_dir) {
          e.sortDirection = 'asc'
        }
        this.last_rendered_sort_dir = !this.last_rendered_sort_dir
      } else {
        if (!this.last_login_sort_dir) {
          e.sortDirection = 'asc'
        }
        this.last_login_sort_dir = !this.last_login_sort_dir
      }
      this.sortData = e
    },
    getUserLastLogin (users) {
      let lastLogin = null
      Array.from(users).forEach((user) => {
        if (user.last_login !== null && (lastLogin === null || lastLogin < user.last_login.date)) {
          lastLogin = user.last_login.date
        }
      })
      return lastLogin
    },
    getUserLastRendered (users) {
      let lastRendered = null
      Array.from(users).forEach((user) => {
        if (user.last_render !== null && (lastRendered === null || lastRendered < user.last_render.date)) {
          lastRendered = user.last_render.date
        }
      })
      return lastRendered
    },
    onRowMouseOver (event) {
      event.currentTarget.classList.add('clients--active')
    },
    expandView (item) {
      window.addEventListener('wheel', this.handleScroll)
      this.currentClient = item
      this.currentClient.associatedUsers = item.associatedUsers
      let div = document.getElementById('clientTable')
      let distanceToTop = div.getBoundingClientRect().top
      let distanceToLeft = div.getBoundingClientRect().left
      let sidebar = document.getElementById('sidebar')
      sidebar.style.borderTop = `3px solid #56ffa2`
      sidebar.style.borderLeft = `3px solid #56ffa2`
      sidebar.style.width = `80%`
      sidebar.style.transition = '0.5s'
      sidebar.style.padding = '10px'
      sidebar.style.right = `${distanceToLeft + 2}px`
      if (distanceToTop > 0) {
        sidebar.style.top = `${distanceToTop + 49}px`
      } else {
        sidebar.style.top = `0`
      }
    },
    hideView () {
      window.removeEventListener('wheel', this.handleScroll)
      let sidebar = document.getElementById('sidebar')
      sidebar.style.transition = '0.5s'
      sidebar.style.width = '0'
      sidebar.style.padding = '0'
      sidebar.style.border = 'none'
    },
    handleScroll () {
      let div = document.getElementById('clientTable')
      if (div) {
        let distanceToTop = div.getBoundingClientRect().top
        let sidebar = document.getElementById('sidebar')
        sidebar.style.transition = '0s'
        if (distanceToTop > 0) {
          sidebar.style.top = `${distanceToTop + 49}px`
        } else {
          sidebar.style.top = `0`
        }
        const sidebarHeight = this.pixelsToPercentage(sidebar.offsetHeight)
        if (distanceToTop <= 226 && sidebarHeight <= 93) {
          sidebar.style.height = `${sidebarHeight + 0.7}%`
        } else if (distanceToTop >= 10 && sidebarHeight >= 57) {
          sidebar.style.height = `${sidebarHeight - 7}%`
        }
      }
    },
    // showUsers (hashid) {
    //   console.log(`show users ${hashid}`)
    // },
    userStatus (hashid) {
      this.startLoading()
      this.currentClient.associatedUsers.filter((user) => {
        if (user.hash_id === hashid) {
          user.is_active = (user.is_active ? 0 : 1)
          this.updateUser(user).then(() => {
            const includeAssociatedUsers = 1
            this.getClients(includeAssociatedUsers).then(() => {
              this.addNotification('success', `'${user.name} user' Successfully updated.`)
              this.finishLoading()
            })
          }, error => {
            this.finishLoading()
            this.addNotification('danger', error)
          })
        }
      })
    },
    clientStatus (hashid) {
      this.startLoading()
      let client = this.currentClient
      if (client.status !== 'deactivated') {
        client.status = 'deactivated'
      } else {
        client.status = 'trial'
      }
      this.updateClient(client).then(() => {
        const includeAssociatedUsers = 1
        this.getClients(includeAssociatedUsers).then(() => {
          this.addNotification('success', `'${client.name} user' Successfully updated.`)
          this.finishLoading()
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    },
    toggleAE (hashid) {
      this.startLoading()
      this.currentClient.filter((user) => {
        if (user.hashid === hashid) {
          user.is_ae_allowed = !user.is_ae_allowed
        }
      })
      setTimeout(() => {
        this.finishLoading()
      }, 300)
    },
    formatDownloadSingleCounter (total, limit) {
      if (!limit) {
        limit = 'NA'
      }
      return `${total}/${limit}`
    },
    formatDownloadCounter (total, limit1, limit2) {
      if (!limit1) {
        limit1 = 'NA'
      }
      if (!limit2) {
        limit2 = 'NA'
      }
      return `${total}/${limit1}  |   ${total}/${limit2}`
    },
    pixelsToPercentage (pixels) {
      var screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      var percentage = (pixels / screenHeight) * 100
      return percentage
    }
  }
}

</script>

<style lang="scss">
  hr {
    border: 0;
    height: 1px;
    background:rgb(125, 119, 119);
    background-image: linear-gradient(to right, #ccc, rgb(125, 119, 119), #ccc);
  }
  .d-flex1 {
    display: flex;
    padding-top: 1%;
    align-items: center;
    justify-content: space-between;
  }
  .clients {
    &__logo {
      display: flex;
      align-items: center;
      .clientLogo {
        margin-right: 10px;
      }

    }
  }
</style>
<style scoped>
.sidebar {
  height: 57%;
  width: 0;
  position: fixed;
  z-index: 1;
  color: #000000;
  background-color: #f9f9f9;
  overflow-x: hidden;
  overflow-y: auto;
  transition: 0.5s;
  padding: 10px 0px 10px 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/client/clients.vue